// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
import DiscountList from '../../ui-helper-elements/DiscountList'
// JS Imports
import {
   formatFloatAsCurrencySymbol,
   formatFloatAsPercent,
} from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalOneTimeDiscountRow() {
   const state = useQuoteContext()
   const { getString } = state
   const displaySectionPermissions = state.featurePermissions['OneTimeTotals']

   if (!displaySectionPermissions.includes(state.user_role)) return null

   if (state.user_view == 'Internal' || state.oneTimeTotal.totalDiscount > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.TotalOneTimeDiscountRow.Header.Title')}
            </div>
            <div className='col'></div>
            <Description
               className='col col-bhr-red'
               title='One Time Discounts'
               content={
                  <>
                     <DiscountList
                        discounts={state.oneTimeTotal.appliedDiscounts}
                     ></DiscountList>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>{getString('global.TotalDiscount')}</b>
                        </div>
                        <div className='col col-bhr-red text-end'>
                           <b>
                              {formatFloatAsCurrencySymbol(
                                 state.oneTimeTotal.totalDiscount,
                                 state.currencyObject,
                              )}
                           </b>
                        </div>
                     </div>
                     <br></br>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           {getString(
                              'product.TotalOneTimeDiscountRow.Header.OneTimeListPrice',
                           )}
                        </div>
                        <div className='col text-end'>
                           {formatFloatAsCurrencySymbol(
                              state.oneTimeTotal.listPrice,
                              state.currencyObject,
                           )}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           {getString('global.TotalDiscount')}
                        </div>
                        <div className='col col-bhr-red text-end'>
                           {formatFloatAsCurrencySymbol(
                              state.oneTimeTotal.totalDiscount,
                              state.currencyObject,
                           )}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>
                              {getString(
                                 'product.TotalOneTimeDiscountRow.Header.OneTimeTotal',
                              )}
                           </b>
                        </div>
                        <div className='col text-end'>
                           <b>
                              {formatFloatAsCurrencySymbol(
                                 state.oneTimeTotal.totalPrice,
                                 state.currencyObject,
                              )}
                           </b>
                        </div>
                     </div>
                     <br></br>
                     <div className='row'>
                        <div className='col text-nowrap'>
                           <b>
                              {getString(
                                 'product.TotalOneTimeDiscountRow.Header.EffectiveDiscount',
                              )}
                           </b>
                        </div>
                        <div className='col col-bhr-red text-end'>
                           <b>
                              {formatFloatAsPercent(
                                 state.oneTimeTotal.totalDiscountPercent,
                              )}
                           </b>
                        </div>
                     </div>
                  </>
               }
            >
               <span className='hoverable'>
                  {formatFloatAsPercent(
                     state.oneTimeTotal.totalDiscountPercent,
                  )}
               </span>
            </Description>
            <div className='col col-bhr-red'>
               {formatFloatAsCurrencySymbol(
                  state.oneTimeTotal.totalDiscount,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
